import { Box, MenuItem, Select, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { useEffect, useState } from "react";
import { constraints, datatypes, inputTypes } from "data/globalData";
import { formatColumnValue } from "components/PimDashboard/data";
import RenderAttributeInputs from "components/PimDashboard/CommonComponents/RenderAttributeInputs/RenderAttributeInputs";
import { attrValAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";
import { EditRounded } from "@mui/icons-material";

const DisplayDetailsWithEditTab = ({
	columns,
	data,
	width = "24%",
	longWidth = "49%",
	name = "Details",
	updateFunction,
	disableEdit = false,
}) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [updatedData, setUpdatedData] = useState({ ...data });
	const [errObj, setErrObj] = useState({});
	useEffect(() => {
		setUpdatedData(data);
	}, [data]);
	const handleCloseModal = () => {
		setUpdatedData(data);
		setModalOpen(false);
	};
	const handleModalOpen = () => {
		setModalOpen(true);
	};
	const handleFormSubmit = (e) => {
		e.preventDefault();
		if (typeof updateFunction === "function") updateFunction(updatedData, handleCloseModal);
	};
	return (
		<Box width="99%" display="flex" flexWrap="wrap" columnGap="1%">
			<Box width="100%" justifyContent="space-between" display="flex" alignItems="center" pt={2} pb={1}>
				<Typography variant="h6" width="80%">
					{name}
				</Typography>
				<Box sx={{ display: disableEdit ? "none" : "block" }}>
					<Button variant="contained" onClick={handleModalOpen} size="small" startIcon={<EditRounded />}>
						Edit
					</Button>
				</Box>
			</Box>
			{columns?.map((row) => {
				// const isDate = labelData[colName]?.isDate;
				return (
					<Box
						width={row.data_type === datatypes.LONGTEXT.key ? longWidth : width}
						key={row?.name}
						display="flex"
						border={`1px solid white`}
						boxSizing="border-box">
						<Typography
							variant="subtitle2"
							color={grey[200]}
							sx={{
								width: "38%",
								p: "10px 2%",
								background: "#000",
								overflow: "hidden",
								borderRadius: "1px 0px 0px 1px",
							}}>
							{row?.name}
						</Typography>
						<Typography
							variant="subtitle2"
							sx={{
								width: "55%",
								p: "10px 2%",
								background: grey[200],
								fontWeight: 400,
								overflow: "hidden",
								borderRadius: " 0px 1px 1px 0px",
							}}>
							{data?.[row?.key] !== undefined ? formatColumnValue(data?.[row?.key], row) : ""}
						</Typography>
					</Box>
				);
			})}

			<Dialog fullWidth maxWidth={"lg"} open={modalOpen} onClose={handleCloseModal} component="form" onSubmit={handleFormSubmit}>
				<Box width="98%" p={2} boxSizing="border-box">
					<Stack width="100%" justifyContent="space-between" flexWrap="wrap" rowGap={1}>
						<Stack direction="row" width="100%" flexWrap="wrap" columnGap="3%" rowGap={1}>
							<Typography variant="h6" width="100%" pl={1}>
								Edit {name}
							</Typography>
							<RenderAttributeInputs
								columns={columns}
								setData={setUpdatedData}
								data={updatedData}
								selectOptObjOptName={attrValAssocObj}
								inputWidth="30%"
							/>
						</Stack>
					</Stack>
				</Box>
				<DialogActions>
					<Button variant="outlined" onClick={handleCloseModal}>
						Cancel
					</Button>
					<Button autoFocus variant="contained" sx={{ mr: 1 }} type="submit">
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};

export default DisplayDetailsWithEditTab;
